import axios from 'axios';
import { dropDown } from './interfaces'

export const getWorktypeGroupDropdown = async (): Promise<dropDown[]> => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }

   const apiURL = process.env.REACT_APP_API_URL;

   const response = await axios.get(`https://${apiURL}/Worktype/Groups`, {
      headers: {
         'Content-Type': 'application/json',
         'Authorization': 'Bearer ' + token,
      }
   });

   const worktypeDropdownData: dropDown[] = response.data as dropDown[];

   return worktypeDropdownData;
};